/* global Config */

// Vendor Libs
import {LOCATION_CHANGE, push} from 'redux-first-history';

// Lib App
import actionsServiceCaller from './actions-service-caller';

const routerMiddleware = store => next => action => {
    const {dispatch, getState} = store;
    const {type} = action || {};
    const state = getState();

    next(action);

    const actions = {
        [LOCATION_CHANGE]: () => handleLocationChange(dispatch, action),
        HISTORY_UPDATE: () => handleHistoryUpdate(dispatch, action.payload, state),
    };

    if (actions[type]) {
        actions[type]();
    }
};

const handleLocationChange = (dispatch, action) => {
    const {payload: {pathname} = {}} = action;

    if (pathname === '/') {
        // NOTE: This has to match `basePath` route in app.js
        dispatch(push('/'));

        dispatch({
            payload: {
                location: {pathname: '/'},
            },
            type: 'HISTORY_UPDATE',
        });
    } else {
        dispatch({
            payload: {
                location: {pathname},
            },
            type: 'HISTORY_UPDATE',
        });
    }
};

const submitAuth = dispatch => {
    const dispatchFetched = jsonResponse => {
        dispatch({
            type: 'AUTH_SET_USER',
            user: jsonResponse,
        });
    };
    const dispatchError = error => {
        console.error(error);
    };
    const config = {
        baseUrl: Config.base.userInfoPath,
        contentType: 'application/json',
        crossDomain: false,
        method: 'GET',
        responseType: 'json',
        timeout: 120000,
    };
    const actionParams = {
        dispatchError,
        dispatchFetched,
        servicesConfig: config,
    };

    return actionsServiceCaller(actionParams);
};

const handleHistoryUpdate = (
    dispatch,
    {location: {pathname: newPathName} = {}},
    {history: {location: {pathname} = {}} = {}}
) => {
    if (pathname === '' && newPathName !== Config.base.loginPath) {
        submitAuth(dispatch);
    }
};

export default routerMiddleware;
